module.exports = __webpack_public_path__ + "img/icon_saved.e4c60344.svg";